import { ReactNode } from 'react';

export const ChatContent = ({ children, isMobile }: { children: ReactNode; isMobile: boolean; }) => (
    <div
        id="chat"
        className={`relative ${isMobile ? 'col-start-1 row-start-1 row-span-full' : 'col-start-1 row-start-2 row-span-full'} flex basis-full min-h-[30vh] lg:min-h-0`}
    >
        {children}
    </div>
);
